import type {DropSide as DropSideType, Over} from '@github-ui/drag-and-drop'
import {DropSide} from '@github-ui/drag-and-drop'

export const getSashPosition = (over: Over | null, side: DropSideType): number | null => {
  if (!over) return null

  return side === DropSide.BEFORE ? over.rect.top : over.rect.bottom
}
